module.exports = __webpack_public_path__ + "static/media/paymentLink.91ac7736.svg";